import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const BcInvoiceSummaryRequestDetailsRow = ({
  title,
  unattemptedTotal,
  successTotal,
  failedTotal
}) => (
  <DetailsRowContainerStyled>
    <h5 style={{ marginRight: "0.5rem" }}>{title}</h5>
    {unattemptedTotal ? (
      <UnattemptedContainerStyled>
        <h5>Unattempted: </h5>
        <h5 style={{ marginLeft: "auto" }}>{unattemptedTotal}</h5>
      </UnattemptedContainerStyled>
    ) : null}
    {failedTotal ? (
      <FailedContainerStyled>
        <h5>Failed: </h5>
        <h5 style={{ marginLeft: "auto" }}>{failedTotal}</h5>
      </FailedContainerStyled>
    ) : null}
    {successTotal ? (
      <SuccessContainerStyled>
        <h5>Successful: </h5>
        <h5 style={{ marginLeft: "auto" }}>{successTotal}</h5>
      </SuccessContainerStyled>
    ) : null}
  </DetailsRowContainerStyled>
);

const DetailsRowContainerStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

const FailedContainerStyled = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.red_g};
  color: #fff;
  border-radius: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 0.5rem 1rem;
  width: 20rem;
`;

const SuccessContainerStyled = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.green_g};
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  width: 20rem;
  margin-left: 0.5rem;
`;

const UnattemptedContainerStyled = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.accent_blue};
  color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  width: 20rem;
  margin-left: auto;
  margin-right: 0.5rem;
`;

BcInvoiceSummaryRequestDetailsRow.propTypes = {
  title: PropTypes.string,
  unattemptedTotal: PropTypes.number,
  successTotal: PropTypes.number,
  failedTotal: PropTypes.number
};

BcInvoiceSummaryRequestDetailsRow.defaultProps = {
  title: ""
};

export default BcInvoiceSummaryRequestDetailsRow;
